import * as swcHelpers from '@swc/helpers';
import * as React from 'react';
import { CommerceToolsApi } from '@grandvisionhq/commercetools';
import { useProductLink } from '@grandvisionhq/products';
import { useIntl, useFeatureToggles } from '@grandvisionhq/state';
import { getNestedProperty, getLocalizedValue, getAttrValue } from '@grandvisionhq/utils';
import { ProductSuggestion as ProductSuggestion$1 } from '../components/ProductSuggestion.js';
import { getProductImageUrl } from '../utils/getProductImageUrl.js';

const ProductSuggestionContainer = ({ staticsUrl , suggestion , onClick ,  })=>{
    const { locale  } = useIntl();
    const { isBynderImagesEnabled  } = useFeatureToggles();
    const props = React.useMemo(()=>{
        const productType = getNestedProperty(suggestion, 'productType.obj.name');
        const isContactLens = CommerceToolsApi.isLenses(productType) || CommerceToolsApi.isContactLensBundle(productType);
        const isSolutions = CommerceToolsApi.isSolutions(productType);
        var _name;
        const name = isContactLens ? getLocalizedValue(suggestion.name, locale) : (_name = suggestion.masterVariant.name) !== null && _name !== void 0 ? _name : '';
        const brand = String(getAttrValue(suggestion.masterVariant, 'brand')) || '';
        const sku = getNestedProperty(suggestion, 'masterVariant.sku');
        const slug = suggestion.slug;
        if (!brand || !name || !productType || !slug || !sku) {
            return null;
        }
        const imageUrl = getProductImageUrl(suggestion, isBynderImagesEnabled, staticsUrl);
        return {
            isContactLens,
            isSolutions,
            name,
            brand,
            imageUrl
        };
    }, [
        suggestion,
        staticsUrl,
        locale
    ]);
    const productUrl = useProductLink(suggestion.slug, getNestedProperty(suggestion, 'masterVariant.sku'), getNestedProperty(suggestion, 'productType.obj.name'));
    const onSuggestionClick = React.useCallback(()=>{
        onClick && onClick(suggestion.objectID, suggestion.position);
    }, [
        suggestion,
        onClick
    ]);
    if (!props) {
        return null;
    }
    return /*#__PURE__*/ React.createElement(ProductSuggestion$1, swcHelpers.extends({}, props, {
        productUrl: productUrl,
        onClick: onSuggestionClick
    }));
};
var ProductSuggestion = ProductSuggestionContainer;

export { ProductSuggestionContainer, ProductSuggestion as default };
//# sourceMappingURL=ProductSuggestionContainer.js.map
